import { Box, Stack } from '@chakra-ui/react'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

export default function IconWithText({
  faIcon,
  iconColor = 'gray.emphasized',
  iconSecondaryColor,
  text,
}: {
  faIcon: IconProp
  iconColor?: string
  iconSecondaryColor?: string
  text: string
}): ReactElement | null {
  // FA duotone is not yet supported in @fortawesome/react-fontawesome
  const additionalStyles =
    iconSecondaryColor == null
      ? {}
      : {
          '--fa-primary-color': chakraTokenToVar(iconColor),
          '--fa-secondary-color': chakraTokenToVar(iconSecondaryColor),
          '--fa-primary-opacity': 1,
          '--fa-secondary-opacity': 1,
        }

  return (
    <Stack
      flex={1}
      direction="row"
      color="fg.muted"
      fontWeight={600}
      align="center"
      spacing="8px"
      fontSize="14px"
    >
      <FontAwesomeIcon
        icon={faIcon}
        color={chakraTokenToVar(iconColor ?? 'gray.emphasized')}
        style={{
          fontSize: '16px',
          ...additionalStyles,
        }}
      />
      <Box>{text}</Box>
    </Stack>
  )
}
